import i18n from "../../resources/I18n";
import { DsdAlerte } from "../DSD/DsdAlerte";
import Configuration from "../../Configuration";
import { DsdContactBloc } from "../DSD/DsdContactBloc";
import "./erreurs.css";
import { DsdVSpacer } from "../DSD/DsdVSpacer";
import { DsdGrid } from "../DSD/DsdGrid";

function ErreurFonctionnelle() {
  return (
    <main>
      <DsdGrid>
        <h1 dangerouslySetInnerHTML={{ __html: i18n.t("assurabilite:titre-barre-progression") }} />
        <DsdAlerte id="alerte-erreur" datatestid="dsd-alerte-erreur" type="inactive" dynamic={true}>
          {i18n.t("assurabilite:texte-erreur-fonctionnelle")}
        </DsdAlerte>
        <DsdContactBloc />
        <dsd-link-action type="return">
          <a id="btn-retour-sommaire" data-testid="btn-retour-sommaire" href={Configuration.obtenirConfigurations().urlSommaire}>
            {i18n.t("assurabilite:btn-retour-sommaire")}
          </a>
        </dsd-link-action>
        <DsdVSpacer espacement="6" />
      </DsdGrid>
    </main>
  );
}

export default ErreurFonctionnelle;
